export default "__VITE_ASSET__46a9aeb5__"